export enum ConnectionState {
  DISCONNECTED = 'disconnected',
  CONNECTING = 'connecting', 
  CONNECTED = 'connected',
  RECONNECTING = 'reconnecting',
  FAILED = 'failed'
}

export interface ConnectionStatus {
  state: ConnectionState;
  lastMessageTime: number;
  error?: string;
} 